export enum WebsiteTypes {
  PublicWebsite = 3,
  PPXWalkIn     = 300,
  PPXQuickQuote = 301
}

export const WebsiteTypeDescriptions: Record<WebsiteTypes, string> = {
  [WebsiteTypes.PublicWebsite]: 'WBAC',
  [WebsiteTypes.PPXWalkIn]: 'PPX Walk-in',
  [WebsiteTypes.PPXQuickQuote]: 'PPX Quick Quote'
};